import Swiper from 'swiper';

export default function() {
    let banners;
    let notice;


    if ($('.topical-section').length) {
        new Swiper('.topical-section', {
            speed: 500,
            spaceBetween: 0,
            slidesPerView: 1,
            loop: true,
            centeredSlides: true,
            effect: 'fade',
            grabCursor: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.topical-section__nav-next',
                prevEl: '.topical-section__nav-prev',
            },
        });
    }

    if ($('.banners').length) {
        new Swiper('.banners', {
            spaceBetween: 15,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.banners__nav-next',
                prevEl: '.banners__nav-prev',
            },
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    if ($('.notice').length) {
        new Swiper('.notice', {
            speed: 400,
            spaceBetween: 0
        });
    }
}




// WEBPACK FOOTER //
// ./frontend/src/js/modules/slider.js